// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD4XlkAxY6n35xBrl6A4Q1c6zVhQ5UN4KY",
  authDomain: "nutrition-trends.firebaseapp.com",
  projectId: "nutrition-trends",
  storageBucket: "nutrition-trends.firebasestorage.app",
  messagingSenderId: "212842423957",
  appId: "1:212842423957:web:bf35c630469411ae931d9c",
  measurementId: "G-91NL8XEP6T"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleAuthProvider = new GoogleAuthProvider();
export const storage = getStorage(app);
// No setPersistence or browserLocalPersistence exports here.